export enum BillFilter {
    Open = 'Open',
    Closed = 'Closed',
    Receipt = 'Receipt',
    Invoice = 'Invoice',
    Overdue = 'Overdue',
}
export enum CompanyFilter {
    Inactive = 'Inactive',
    Internal = 'Internal',
    Marketing = 'Marketing',
    isTravelAgency = 'isTravelAgency',
}
export enum CustomerFilter {
    isVip = 'isVip',
    isInHouse = 'isInHouse',
    isPaymaster = 'isPaymaster',
}
export enum SpaceFilter {
    Clean = 'Clean',
    Dirty = 'Dirty',
    Inspected = 'Inspected',
    OutOfOrder = 'OutOfOrder',
    OutOfService = 'OutOfService',
    Unassigned = 'Unassigned',
}
export enum ReservationFilter {
    Canceled = 'Canceled',
    CheckInOnLine = 'CheckInOnLine',
    CheckOut = 'CheckOut',
    CheckOutOnLine = 'CheckOutOnLine',
    Confirmed = 'Confirmed',
    Inquired = 'Inquired',
    Optional = 'Optional',
    Past = 'Past',
    CheckOutMissed = 'CheckOutMissed',
    ToBeCheckedOut = 'ToBeCheckedOut',
    CheckedIn = 'CheckedIn',
    CheckInMissed = 'CheckInMissed',
    ToBeCheckedIn = 'ToBeCheckedIn',
    Future = 'Future',
}

export type AssistantFilterChips = `${BillFilter | CompanyFilter | CustomerFilter | SpaceFilter | ReservationFilter}`;
